import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
var SensibleService = /** @class */ (function () {
    function SensibleService(http) {
        this.http = http;
        this.cargadoSensible = true;
        this.sensible = [];
        this.sensibleRFL = [];
        this.sensibleRFC = [];
        this.sensibleRFP = [];
        this.sensibleRCL = [];
        this.sensibleRCC = [];
        this.sensibleRCP = [];
        this.cargarAntipigmanto();
    }
    SensibleService.prototype.cargarAntipigmanto = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.http.get('assets/data/dataLineas.json')
                .subscribe(function (resp) {
                _this.sensible = resp;
                _this.sensibleRFL = _this.sensible[6].rutinafacial.limpieza;
                _this.sensibleRFC = _this.sensible[6].rutinafacial.cuidado;
                _this.sensibleRFP = _this.sensible[6].rutinafacial.proteccion;
                _this.sensibleRCL = _this.sensible[6].rutinacorporal.limpieza;
                _this.sensibleRCC = _this.sensible[6].rutinacorporal.cuidado;
                _this.sensibleRCP = _this.sensible[6].rutinacorporal.proteccion;
                setTimeout(function () {
                    _this.cargadoSensible = false;
                }, Math.floor(Math.random() * (1600 - 600)) + 600);
                resolve();
            });
        });
    };
    SensibleService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    SensibleService = tslib_1.__decorate([
        Injectable({
            providedIn: 'root'
        })
    ], SensibleService);
    return SensibleService;
}());
export { SensibleService };
//# sourceMappingURL=sensible.service.js.map